/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const DeleteSelectedBranchesActionsWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: token('color.background.selected'),
  padding: `${gridSize() / 2}px ${gridSize()}px`,
  margin: `${gridSize() * 1.5}px 0`,
  position: 'relative',
});

export const CancelButtonWrapper = styled.div({
  marginRight: `${gridSize()}px`,
  position: 'absolute',
  right: 0,
});
